import React from "react";
import { Spinner, Flex } from "@chakra-ui/react";
import { Wrapper } from "components";
import { useGetOrganizationAdminQuery } from "requests";
import { Edit, View } from "./components";

const Admin: React.FC = () => {
  const [edit, setEdit] = React.useState(false);

  const { data, loading } = useGetOrganizationAdminQuery();

  const admin = data?.users?.collection?.[0];

  return (
    <Wrapper>
      {loading || !admin ? (
        <Flex justify="center">
          <Spinner />
        </Flex>
      ) : (
        <>
          {edit && (
            <Edit
              admin={admin}
              onCancel={() => setEdit(false)}
              onSuccess={() => setEdit(false)}
            />
          )}
          {!edit && <View admin={admin} onEdit={() => setEdit(true)} />}
        </>
      )}
    </Wrapper>
  );
};

export default Admin;
